import { PhysicalContactDetails } from 'src/Components/Contacts/PhysicalContactDetails';
import useFetchExportedContact from 'src/Hooks/Queries/useFetchExportedContact';

import { Props } from './ExportedPhysicalContactDetails.types';

const ExportedPhysicalContactDetails = ({ contactId, token }: Props) => {
  const { data: contact } = useFetchExportedContact({ contactId, token });

  return contact && <PhysicalContactDetails contact={contact} />;
};

export default ExportedPhysicalContactDetails;
